import { Alert, Typography } from "@mui/material";
import { CopyIconButton } from "@shared/components/CopyIconButton";

type Props = {
  link: string;
};

export const ImpersonateLinkDialogContent = ({ link }: Props) => {
  return (
    <>
      <Typography>
        Open this link in an incognito/private window to sign in as this user,
        without affecting your own session.
      </Typography>
      <Alert
        severity="info"
        icon={false}
        action={
          <CopyIconButton text={link} ariaLabel="Copy impersonation link" />
        }
        sx={{ mt: 2, wordBreak: "break-all" }}
      >
        {link}
      </Alert>
      <Typography color="secondary" variant="body2" sx={{ mt: 1 }}>
        This link is single-use and expires shortly.
      </Typography>
    </>
  );
};
